<div class="pt-3" [formGroup]="formGroup">
  <dgx-dfb-checkbox
    [field]="field"
    [formControlName]="field.controlName"
    [validate]="validateField"
  >
  </dgx-dfb-checkbox>
</div>
